var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PriceEndpointPushDataProvider } from '../pushDataProvider';
import { ChartIQContentNoPushDataProvider } from './ChartIQContentNoPushDataProvider';
/**
 * Handling data for chart-iq-content
 */
var ChartIQContentDataProvider = /** @class */ (function (_super) {
    __extends(ChartIQContentDataProvider, _super);
    /**
     * Constructor
     *
     * @param client
     * @param config
     */
    function ChartIQContentDataProvider(client, config) {
        var _this = _super.call(this, client, config) || this;
        _this._subscription = {};
        _this._benchmarkSubscriptions = new Map();
        _this._pushDataProvider = new PriceEndpointPushDataProvider(client, _this.config.API_PRICES_SUBSCRIPTION_ENDPOINT);
        return _this;
    }
    /**
     * Creates subscription for main notation
     *
     * @param idNotation
     * @param priceType
     * @param cb
     * @param err
     */
    ChartIQContentDataProvider.prototype.createMainInstrumentPriceSubscription = function (idNotation, priceType, cb, err) {
        if (!this._subscription.id) {
            var id = String(idNotation);
            var type = String(priceType);
            var subscription = this.createSubscription(id, cb, err);
            this._subscription = { id: id, type: type, subscription: subscription };
        }
    };
    /**
     * Creates a subscription for a benchmark
     *
     * @param idNotation
     * @param priceType
     * @param cb
     * @param err
     */
    ChartIQContentDataProvider.prototype.createBenchmarkSubscription = function (idNotation, priceType, cb, err) {
        return __awaiter(this, void 0, void 0, function () {
            var id, subscription;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = String(idNotation);
                        if (!(!this._benchmarkSubscriptions.has(id) && id !== this._subscription.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getReferenceData(id)];
                    case 1:
                        _a.sent();
                        subscription = this.createSubscription(id, cb, err);
                        this._benchmarkSubscriptions.set(id, subscription);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Unsubscribe of all benchmarks
     */
    ChartIQContentDataProvider.prototype.destroyBenchmarkSubscriptions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var subscriptions;
            var _this = this;
            return __generator(this, function (_a) {
                subscriptions = [];
                this._benchmarkSubscriptions.forEach(function (val, key) {
                    subscriptions.push(_this.destroyBenchmarkSubscription(key));
                });
                return [2 /*return*/, Promise.all(subscriptions)];
            });
        });
    };
    /**
     * Destroys the benchmark subscription for the passed notation
     *
     * @param idNotation
     */
    ChartIQContentDataProvider.prototype.destroyBenchmarkSubscription = function (idNotation) {
        return __awaiter(this, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = String(idNotation);
                        if (!this._benchmarkSubscriptions.has(id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.unobserveNotation(id)];
                    case 1:
                        _a.sent();
                        this._benchmarkSubscriptions.get(id).unsubscribe();
                        this._benchmarkSubscriptions.delete(id);
                        this.refData.delete(id);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Checks whether benchmark with idNotation is already subscribed
     *
     * @param idNotation
     */
    ChartIQContentDataProvider.prototype.isBenchmarkSubscribed = function (idNotation) {
        var id = String(idNotation);
        return this._benchmarkSubscriptions.has(id);
    };
    /**
     * Unsubscribe all and reset states
     */
    ChartIQContentDataProvider.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _super.prototype.destroy.call(this);
                        return [4 /*yield*/, this.destroyPriceSubscription()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.destroyBenchmarkSubscriptions()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Alias "destroyMainSubscription"
     */
    ChartIQContentDataProvider.prototype.destroyPriceSubscription = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.destroyMainSubscription()];
            });
        });
    };
    /**
     * Destroy main subscription
     */
    ChartIQContentDataProvider.prototype.destroyMainSubscription = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._subscription.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.unobserveNotation(this._subscription.id)];
                    case 1:
                        _a.sent();
                        if (this._subscription.subscription) {
                            this._subscription.subscription.unsubscribe();
                        }
                        this.refData.delete(this._subscription.id);
                        this._subscription = {};
                        this.eventList = {};
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets main subscription
     */
    ChartIQContentDataProvider.prototype.getMainSubscription = function () {
        return this._subscription;
    };
    /**
     * Gets benchmark subscriptions
     */
    ChartIQContentDataProvider.prototype.getBenchmarkSubscriptions = function () {
        return this._benchmarkSubscriptions;
    };
    /**
     * Creates push subscription
     *
     * @param idNotation
     * @param cb
     * @param err
     */
    ChartIQContentDataProvider.prototype.createSubscription = function (idNotation, cb, err) {
        return this._pushDataProvider
            .observe({
            idNotation: idNotation,
            quality: this.config.API_PRICES_QUALITY,
        })
            .subscribe(function (result) {
            if (result) {
                var price = result.data.latest.price;
                var date = Date.parse(result.data.latest.time);
                var volume = result.data.latest.tradingVolume;
                if (price !== null && date !== null) {
                    cb({ volume: volume, date: date, value: price });
                }
            }
        }, function (error) {
            err(error);
        });
    };
    /**
     * Unobserve notation subsample
     *
     * @param idNotation
     */
    ChartIQContentDataProvider.prototype.unobserveNotation = function (idNotation) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._pushDataProvider.clearByNotation(idNotation)];
            });
        });
    };
    return ChartIQContentDataProvider;
}(ChartIQContentNoPushDataProvider));
export { ChartIQContentDataProvider };
//# sourceMappingURL=ChartIQContentDataProvider.js.map